// Funciones para traducción.
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import * as FxFetch from '../fx/FxFetch';
import { useTranslation } from './useTranslation';

export const useAccess = (modName) => {
  let mod = modName;
  let ar = JSON.parse(sessionStorage.getItem('access') || null);
  const [{ trans }] = useTranslation();

  const _storeInSession = (ar) => {
    sessionStorage.setItem('access', JSON.stringify(ar));
  }

  const _getItem = (key) => {
    FxLog.infox('useAccess._getItem', '...key:', key);
    
    // 1. Si no hay clave, o no hay datos de acceso cargados, devolvemos 'W' por seguridad/defecto
    if (!key || !ar) {
      return 'W';
    }

    // 2. Si la clave existe en el objeto de permisos, devolvemos su valor ('W', 'R', 'N')
    if (ar[key]) {
      return ar[key];
    } else {
      // 3. Si no existe la clave:
      // Filtramos por las preferencias conocidas que no deben disparar creación en BD
      const isPref = ['Prefs-Usuario', 'Prefs-Locales', 'Prefs-User', 'Prefs-Locals'].includes(key);
      
      if (!isPref) {
        FxLog.errorx('useAccess._getItem', 'NO HAY ACCESO PARA: ' + key + '\nSe intentará crear.');
        createAccess(key);
      }

      // 4. CRÍTICO: Devolvemos 'W' en lugar de la propia 'key'
      // Esto asegura que strAccessQ sea 'W' y no "Presupuestos"
      return 'W';
    }
  }

  const createAccess = (key) => {
    Promise.all([FxFetch.doJsonX("sett/sec/groups/set_new_access", {"txSecAccess":key})]).then((result) => {
      if (result[0]) {
        if (result[0].theStatus === 'error') {
          //FxLog.errorx('useAccess.createAccess', 'NO se ha podido crear el acceso. txSecAccess:' + key);
          if (result[0].theValue==='rv_id_exists') {
            FxLog.errorx('useAccess.createAccess', 'The ID(inSecAccess) already exists.');
          }
        }
        if (result[0].theStatus === 'OK') {
          FxLog.infox('useAccess.createAccess', 'SÍ se ha podido crear el acceso. txSecAccess:' + key);
        }
      }
    });
  }

  const _isMatchingLang = () => {
    if (ar[trans('field.clients')]) {
      return true;
    } else {
      return false;
    }
  }

  const _isFullAccess = () => {
    FxLog.infox('useAccess._isFullAccess', '..._getItem(mod):', _getItem(mod));
    if (_getItem(mod) === 'W') {
      return true;
    } else {
      return false;
    }
  }

  return [
    {
      storeAccessInSession: _storeInSession,
      access: _getItem,
      isFullAccess: _isFullAccess,
      isMatchingLang: _isMatchingLang,
    },
  ];
};
